jQuery(($) => {
    var $body = $(document.body);
    
    $body.on('click', '[data-toggle-body-class]', function(){
        var className = $(this).data('toggle-body-class');
        $body.toggleClass(className);
    });
    $body.on('click', '[data-add-body-class]', function(){
        var className = $(this).data('add-body-class');
        $body.addClass(className);
    });
    $body.on('click', '[data-remove-body-class]', function(){
        var className = $(this).data('remove-body-class');
        $body.removeClass(className);
    });
});
